import { render, staticRenderFns } from "./StreamSettings.vue?vue&type=template&id=79a7f1c4&"
import script from "./StreamSettings.vue?vue&type=script&lang=js&"
export * from "./StreamSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports